import { useCallback, useRef } from 'react';
import { Animated } from 'react-native';

/**
 * Horizontal shake for error feedback.
 */
export default function useShake() {
	const translateX = useRef(new Animated.Value(0)).current;

	const shake = useCallback(() => {
		translateX.setValue(0);
		Animated.sequence(
			[-8, 8, -6, 6, 0].map((toValue) => Animated.timing(translateX, { toValue, duration: 50, useNativeDriver: true })),
		).start();
	}, [translateX]);

	return { translateX, shake };
}
